// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ALa2","fullView":"styles_fullView__2pQWM"};